import { Controller } from "@hotwired/stimulus"

// The S4A pitch update's send confirmation. Same job as the SPT report's
// send controller minus the reset choice (this report has no cursor to
// advance), so it rides the ONE app modal (window.appConfirm) instead of
// building a second overlay. On confirm it copies the edited email into
// the hidden body_html field and submits natively (the form is turbo:false,
// where turbo_confirm is dead, which is why this exists at all).
//
// Values: message (%{to} is replaced with the live To field), label.
export default class extends Controller {
  static targets = ["editableBody", "bodyField"]
  static values = { message: String, label: String }

  connect() {
    // A bfcache back-restore resurrects the page with the latch still set,
    // and a later Send would then skip the modal (the SPT controller's
    // Seat 3 finding, same shape here).
    this.boundPageshow = (e) => { if (e.persisted) this.confirmed = false }
    window.addEventListener("pageshow", this.boundPageshow)
  }

  disconnect() {
    window.removeEventListener("pageshow", this.boundPageshow)
  }

  submit(event) {
    if (this.confirmed) return
    event.preventDefault()
    if (this.pending) return
    this.pending = true

    const to = this.element.querySelector("[name=to_recipients]")?.value?.trim()
    const message = (this.messageValue || "Send this update?")
      .replace("%{to}", to || "the address in the To field")

    const confirmation = window.appConfirm(message, { confirmLabel: this.labelValue || "Send" })
    // The house dialog only unhides itself, so focus stays on the button
    // behind the overlay; move it in or a keyboard user cannot reach the
    // buttons and Enter silently re-fires submit.
    document.querySelector("#turbo-confirm-dialog [data-confirm-accept]")?.focus()

    confirmation.then((ok) => {
      this.pending = false
      if (!ok) return
      if (this.hasEditableBodyTarget && this.hasBodyFieldTarget) {
        this.bodyFieldTarget.value = this.editableBodyTarget.innerHTML
      }
      this.confirmed = true
      const button = this.element.querySelector("input[type=submit], button[type=submit]")
      this.element.requestSubmit()
      // AFTER requestSubmit so the submitter still rides the payload. The
      // form is turbo:false, so nothing else disables it, and a second
      // click would sail past the confirmed latch into a second email.
      if (button) {
        button.disabled = true
        if (button.value !== undefined) button.value = "Sending..."
      }
    })
  }
}
